import React, { useCallback } from 'react';
import PilotagePanelCollapsed from './PilotagePanelCollapsed';
import PilotagePanelExpanded from './PilotagePanelExpanded';
import { usePilotageStore } from '@/stores/pilotageStore';
import { usePlanningStore } from '@/stores/planningStore';
import { useAlertes } from '@/hooks/useAlertes';

interface PilotagePanelProps {
  entrepriseId: string;
}

/**
 * Panneau Centre de Pilotage - Orchestration de l'état ouvert/fermé
 * Affiche les alertes et notifications importantes pour le pilotage des chantiers
 */
const PilotagePanel = ({ entrepriseId }: PilotagePanelProps) => {
  const { isOpen, openPanel, closePanel } = usePilotageStore();
  const closePlanning = usePlanningStore((state) => state.closePanel);
  const { alertes, compteurs, loading, refetch, marquerCommeLue } = useAlertes({ entrepriseId });

  // Handler pour ouvrir le panneau (ferme d'abord Planning)
  const handleOpenPanel = useCallback(() => {
    closePlanning();
    openPanel();
  }, [closePlanning, openPanel]);

  return (
    <>
      {/* ═══════════════════════════════════════════════════════════════
          ONGLET PLIÉ - Visible quand fermé
          ═══════════════════════════════════════════════════════════════ */}
      <PilotagePanelCollapsed
        isVisible={!isOpen}
        onExpand={handleOpenPanel}
        compteurs={compteurs}
      />

      {/* ═══════════════════════════════════════════════════════════════
          OVERLAY - Fond sombre quand ouvert (z-[55] pour passer au-dessus du bouton Guide)
          ═══════════════════════════════════════════════════════════════ */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/60 z-[55] backdrop-blur-sm"
          onClick={closePanel}
        />
      )}

      {/* ═══════════════════════════════════════════════════════════════
          PANNEAU DÉPLIÉ - Visible quand ouvert
          ═══════════════════════════════════════════════════════════════ */}
      <PilotagePanelExpanded
        isVisible={isOpen}
        onCollapse={closePanel}
        alertes={alertes}
        compteurs={compteurs}
        loading={loading}
        onRefresh={refetch}
        onMarquerLue={marquerCommeLue}
      />
    </>
  );
};

export default PilotagePanel;
